import { useTranslation } from 'react-i18next';
import { toUpperFirstChar } from 'utils';

import { useStyles } from './style';
import clsx from 'clsx';

interface Classes {
  box?: string;
  boxWrapper?: string;
}

interface Props {
  title: string;
  cls?: Classes;
}

const TitledBox: React.FC<Props> = ({ title, cls, children }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.boxWrapper, cls?.boxWrapper)}>
      <h3 className={classes.title}>{toUpperFirstChar(t(title))}</h3>
      <div className={clsx(classes.box, cls?.box)}>{children}</div>
    </div>
  );
};

export default TitledBox;
